const errors_en = {
  '0-A': {
    modMtch: [],
    accMode: [
      {
        errorHeading: 'Accuracy - Change the Wrong for more than three',
        correct: 'This is a sample text.',
        errorType: 'modAcc',
        context: { length: 23, offset: 0 },
        message: 'Try Rewriting for Clarity',
        replacements: [
          [
            '#@-@# THis',
            '#@+@# This',
            'is  a',
            '#@-@# samplee',
            '#@+@# sample',
            'text.',
          ],
        ],
        highlights: [
          {
            wrong: 'THis',
            offset: 0,
            replace: 'This',
            length: 4,
            model: 'accuracy',
            tread_id: '0-A-0',
          },
          {
            wrong: 'samplee',
            offset: 10,
            replace: 'sample',
            length: 7,
            model: 'accuracy',
            tread_id: '0-A-0',
          },
        ],
        length: 23,
        offset: 0,
        wrong: 'THis is a samplee text.',
        Color: '#E82D53',
        ColorLight: '#FFDDDD',
        UnderLine: 'SolidLine',
        rule: {
          category: { id: 'GINMods', name: 'GINMods' },
          description: 'GINMods',
          id: 'GINMods',
          issueType: 'modAcc',
        },
        model: 'accuracy',
        ChkiD: '0-A-0',
      },
    ],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [],
    readability: 6,
    errors: {
      SpellError: 0,
      Suggestion: 0,
      GrammarError: 0,
      redundency: 0,
      clarity: 0,
      accuracy: 0,
      style: 0,
      syntax: 0,
      vocabulary: 0,
      modelsuggestions: 0,
      accuracy_suggestions: 1,
      clarity_suggestions: 0,
      style_suggestions: 0,
    },
    ChkiD: '0-A',
    text_details: {
      characters: 23,
      words: 5,
      speaking_time: 2,
      reading_time: 1,
      readability: 6,
    },
  },
  '1-A': {
    modMtch: [],
    accMode: [
      {
        errorHeading: 'Accuracy - Change the Wrong for more than three',
        correct:
          'GrammarIn will detect your mistakes using its AI and helps you write better.',
        errorType: 'modAcc',
        context: { length: 78, offset: 0 },
        message: 'Try Rewriting for Clarity',
        replacements: [
          [
            'GrammarIn',
            '#@-@# wills',
            '#@+@# will',
            '#@-@# detected',
            '#@+@# detect',
            '#@-@# you',
            '#@+@# your',
            'mistakes',
            '#@-@# usng',
            '#@+@# using',
            'its  AI  and  helps',
            '#@-@# your',
            '#@+@# you',
            'write  better.',
          ],
        ],
        highlights: [
          {
            wrong: 'wills detected you',
            offset: 10,
            replace: 'will detect your',
            length: 18,
            model: 'accuracy',
            tread_id: '1-A-0',
          },
          {
            wrong: 'usng',
            offset: 38,
            replace: 'using',
            length: 4,
            model: 'accuracy',
            tread_id: '1-A-0',
          },
          {
            wrong: 'your',
            offset: 60,
            replace: 'you',
            length: 4,
            model: 'accuracy',
            tread_id: '1-A-0',
          },
        ],
        length: 78,
        offset: 0,
        wrong:
          'GrammarIn wills detected you mistakes usng its AI and helps your write better.',
        Color: '#E82D53',
        ColorLight: '#FFDDDD',
        UnderLine: 'SolidLine',
        rule: {
          category: { id: 'GINMods', name: 'GINMods' },
          description: 'GINMods',
          id: 'GINMods',
          issueType: 'modAcc',
        },
        model: 'accuracy',
        ChkiD: '1-A-0',
      },
    ],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [],
    readability: 18,
    errors: {
      SpellError: 0,
      Suggestion: 0,
      GrammarError: 0,
      redundency: 0,
      clarity: 0,
      accuracy: 0,
      style: 0,
      syntax: 0,
      vocabulary: 0,
      modelsuggestions: 0,
      accuracy_suggestions: 1,
      clarity_suggestions: 0,
      style_suggestions: 0,
    },
    ChkiD: '1-A',
    text_details: {
      characters: 78,
      words: 13,
      speaking_time: 6,
      reading_time: 3,
      readability: 18,
    },
  },
  '2-A': {
    modMtch: [],
    accMode: [
      {
        errorHeading: 'Accuracy - Change the Wrong for more than three',
        correct:
          'He walked to the market yesterday and bought some fruits. The apple was very sweet, but she did not eat it.',
        errorType: 'modAcc',
        context: { length: 95, offset: 0 },
        message: 'Try Rewriting for Clarity',
        replacements: [
          [
            '#@-@# he',
            '#@+@# He',
            '#@-@# walk',
            '#@+@# walked',
            'to',
            '#@+@# the',
            'market  yesterday  and',
            '#@-@# buyed',
            '#@+@# bought',
            'some  fruits.',
            '#@-@# the',
            '#@+@# The',
            'apple  was  very',
            '#@-@# sweet',
            '#@+@# sweet,',
            'but  she',
            '#@+@# did',
            'not  eat  it.',
          ],
        ],
        highlights: [
          {
            wrong: 'he walk',
            offset: 0,
            replace: 'He walked',
            length: 7,
            model: 'accuracy',
            tread_id: '2-A-0',
          },
          {
            wrong: 'market',
            offset: 11,
            replace: 'the market',
            length: 6,
            model: 'accuracy',
            tread_id: '2-A-0',
          },
          {
            wrong: 'buyed',
            offset: 32,
            replace: 'bought',
            length: 5,
            model: 'accuracy',
            tread_id: '2-A-0',
          },
          {
            wrong: 'the',
            offset: 51,
            replace: 'The',
            length: 3,
            model: 'accuracy',
            tread_id: '2-A-0',
          },
          {
            wrong: 'sweet',
            offset: 70,
            replace: 'sweet,',
            length: 5,
            model: 'accuracy',
            tread_id: '2-A-0',
          },
          {
            wrong: 'not',
            offset: 84,
            replace: 'did not',
            length: 3,
            model: 'accuracy',
            tread_id: '2-A-0',
          },
        ],
        length: 95,
        offset: 0,
        wrong:
          'he walk to market yesterday and buyed some fruits. the apple was very sweet but she not eat it.',
        Color: '#E82D53',
        ColorLight: '#FFDDDD',
        UnderLine: 'SolidLine',
        rule: {
          category: { id: 'GINMods', name: 'GINMods' },
          description: 'GINMods',
          id: 'GINMods',
          issueType: 'modAcc',
        },
        model: 'accuracy',
        ChkiD: '2-A-0',
      },
    ],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [],
    readability: 16,
    errors: {
      SpellError: 0,
      Suggestion: 0,
      GrammarError: 0,
      redundency: 0,
      clarity: 0,
      accuracy: 0,
      style: 0,
      syntax: 0,
      vocabulary: 0,
      modelsuggestions: 0,
      accuracy_suggestions: 1,
      clarity_suggestions: 0,
      style_suggestions: 0,
    },
    ChkiD: '2-A',
    text_details: {
      characters: 95,
      words: 19,
      speaking_time: 9,
      reading_time: 5,
      readability: 16,
    },
  },
  '3-A': {
    modMtch: [],
    accMode: [
      {
        errorHeading: 'Accuracy - Change the Wrong for more than three',
        correct:
          'We go to the park every Sunday. They are playing with their ball now.',
        errorType: 'modAcc',
        context: { length: 67, offset: 0 },
        message: 'Try Rewriting for Clarity',
        replacements: [
          [
            '#@-@# we  goes',
            '#@+@# We  go',
            'to',
            '#@+@# the',
            'park  every',
            '#@-@# sundays.',
            '#@+@# Sunday.',
            '#@-@# they',
            '#@+@# They',
            '#@-@# is',
            '#@+@# are',
            'playing  with',
            '#@-@# there',
            '#@+@# their',
            'ball  now.',
          ],
        ],
        highlights: [
          {
            wrong: 'we goes',
            offset: 0,
            replace: 'We go',
            length: 7,
            model: 'accuracy',
            tread_id: '3-A-0',
          },
          {
            wrong: 'park',
            offset: 11,
            replace: 'the park',
            length: 4,
            model: 'accuracy',
            tread_id: '3-A-0',
          },
          {
            wrong: 'sundays. they is',
            offset: 22,
            replace: 'Sunday. They are',
            length: 16,
            model: 'accuracy',
            tread_id: '3-A-0',
          },
          {
            wrong: 'there',
            offset: 52,
            replace: 'their',
            length: 5,
            model: 'accuracy',
            tread_id: '3-A-0',
          },
        ],
        length: 67,
        offset: 0,
        wrong:
          'we goes to park every sundays. they is playing with there ball now.',
        Color: '#E82D53',
        ColorLight: '#FFDDDD',
        UnderLine: 'SolidLine',
        rule: {
          category: { id: 'GINMods', name: 'GINMods' },
          description: 'GINMods',
          id: 'GINMods',
          issueType: 'modAcc',
        },
        model: 'accuracy',
        ChkiD: '3-A-0',
      },
    ],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [],
    readability: 12,
    errors: {
      SpellError: 0,
      Suggestion: 0,
      GrammarError: 0,
      redundency: 0,
      clarity: 0,
      accuracy: 0,
      style: 0,
      syntax: 0,
      vocabulary: 0,
      modelsuggestions: 0,
      accuracy_suggestions: 1,
      clarity_suggestions: 0,
      style_suggestions: 0,
    },
    ChkiD: '3-A',
    text_details: {
      characters: 67,
      words: 13,
      speaking_time: 6,
      reading_time: 3,
      readability: 12,
    },
  },
} as const;

const errors_es = {
  '0-A': {
    modMtch: [],
    accMode: [
      {
        errorHeading: 'Accuracy - Change the Wrong for more than three',
        correct: 'Este es un texto deejemplo.',
        errorType: 'modAcc',
        context: { length: 27, offset: 0 },
        message: 'Try Rewriting for Clarity',
        replacements: [
          ['#@-@# este', '#@+@# Este', 'es  un  texto  deejemplo.'],
        ],
        highlights: [
          {
            wrong: 'este',
            offset: 0,
            replace: 'Este',
            length: 4,
            model: 'accuracy',
            tread_id: '0-A-0',
          },
        ],
        length: 27,
        offset: 0,
        wrong: 'este es un texto deejemplo.',
        Color: '#E82D53',
        ColorLight: '#FFDDDD',
        UnderLine: 'SolidLine',
        rule: {
          category: { id: 'GINMods', name: 'GINMods' },
          description: 'GINMods',
          id: 'GINMods',
          issueType: 'modAcc',
        },
        model: 'accuracy',
        ChkiD: '0-A-0',
      },
    ],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [
      {
        Color: '#33B66C',
        ColorLight: '#CBEFDB',
        UnderLine: 'DottedLine',
        context: { length: 9, offset: 17, text: 'este es un texto deejemplo.' },
        contextForSureMatch: 0,
        errorHeading: 'Misspelled Word',
        errorType: 'style',
        ignoreForIncompleteSentence: false,
        length: 9,
        location: -1,
        message: 'Se ha encontrado un posible error ortogr\u00e1fico.',
        offset: 17,
        replacements: [{ value: 'de ejemplo' }],
        rule: {
          category: { id: 'TYPOS', name: 'Posible error ortogr\u00e1fico' },
          description: 'Posible error de ortograf\u00eda',
          id: 'MORFOLOGIK_RULE_ES',
          issueType: 'misspelling',
        },
        sentence: 'este es un texto deejemplo.',
        shortMessage: 'Error de ortograf\u00eda',
        type: { typeName: 'UnknownWord' },
        wrong: 'deejemplo',
        ChkiD: '0-A-0',
        text: 'este es un texto deejemplo.',
      },
    ],
    readability: 0,
    errors: {
      GrammarError: 0,
      SpellError: 0,
      Suggestion: 0,
      accuracy: 0,
      accuracy_suggestions: 1,
      clarity: 0,
      clarity_suggestions: 0,
      modelsuggestions: 0,
      redundency: 0,
      style: 0,
      style_suggestions: 0,
      syntax: 0,
      vocabulary: 0,
    },
    ChkiD: '0-A',
    text_details: {
      characters: 27,
      words: 5,
      speaking_time: 2,
      reading_time: 1,
      readability: 0,
    },
  },
  '1-A': {
    modMtch: [],
    accMode: [
      {
        errorHeading: 'Accuracy - Change the Wrong for more than three',
        correct:
          'GrammarIn detectar\u00e1 tus errores con su inteligencia artificial y te ayudar\u00e1 a escribir mejor.',
        errorType: 'modAcc',
        context: { length: 92, offset: 0 },
        message: 'Try Rewriting for Clarity',
        replacements: [
          [
            'GrammarIn  detectar\u00e1  tus  errores',
            '#@-@# Con',
            '#@+@# con',
            'su',
            '#@-@# inteligenciaartificial',
            '#@+@# inteligencia  artificial',
            'y  te  ayudar\u00e1  a  escribir  mejor.',
          ],
        ],
        highlights: [
          {
            wrong: 'Con',
            offset: 32,
            replace: 'con',
            length: 3,
            model: 'accuracy',
            tread_id: '1-A-0',
          },
          {
            wrong: 'inteligenciaartificial',
            offset: 39,
            replace: 'inteligencia artificial',
            length: 22,
            model: 'accuracy',
            tread_id: '1-A-0',
          },
        ],
        length: 92,
        offset: 0,
        wrong:
          'GrammarIn detectar\u00e1 tus errores Con su inteligenciaartificial y te ayudar\u00e1 a escribir mejor.',
        Color: '#E82D53',
        ColorLight: '#FFDDDD',
        UnderLine: 'SolidLine',
        rule: {
          category: { id: 'GINMods', name: 'GINMods' },
          description: 'GINMods',
          id: 'GINMods',
          issueType: 'modAcc',
        },
        model: 'accuracy',
        ChkiD: '1-A-0',
      },
    ],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [],
    readability: 0,
    errors: {
      GrammarError: 0,
      SpellError: 0,
      Suggestion: 0,
      accuracy: 0,
      accuracy_suggestions: 1,
      clarity: 0,
      clarity_suggestions: 0,
      modelsuggestions: 0,
      redundency: 0,
      style: 0,
      style_suggestions: 0,
      syntax: 0,
      vocabulary: 0,
    },
    ChkiD: '1-A',
    text_details: {
      characters: 94,
      words: 13,
      speaking_time: 6,
      reading_time: 3,
      readability: 0,
    },
  },
  '2-A': {
    modMtch: [],
    accMode: [],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [
      {
        Color: '#33B66C',
        ColorLight: '#CBEFDB',
        UnderLine: 'DottedLine',
        context: {
          length: 6,
          offset: 12,
          text: 'Ayer fue al ercado y compr\u00f3 fruta. la manzana estaba muy d...',
        },
        contextForSureMatch: 0,
        errorHeading: 'Misspelled Word',
        errorType: 'style',
        ignoreForIncompleteSentence: false,
        length: 6,
        location: 3,
        message: 'Se ha encontrado un posible error ortogr\u00e1fico.',
        offset: 12,
        replacements: [
          { value: 'mercado' },
          { value: 'cercado' },
          { value: 'errado' },
          { value: 'recado' },
          { value: 'erado' },
          { value: 'encado' },
          { value: 'encad\u00f3' },
        ],
        rule: {
          category: { id: 'TYPOS', name: 'Posible error ortogr\u00e1fico' },
          description: 'Posible error de ortograf\u00eda',
          id: 'MORFOLOGIK_RULE_ES',
          issueType: 'misspelling',
        },
        sentence: 'Ayer fue al ercado y compr\u00f3 fruta.',
        shortMessage: 'Error de ortograf\u00eda',
        type: { typeName: 'UnknownWord' },
        wrong: 'ercado',
        ChkiD: '2-A-0',
        text: 'Ayer fue al ercado y compro\u0301 fruta. la manzana estaba muy dulce, pero no se lacomio\u0301.',
      },
      {
        Color: '#33B66C',
        ColorLight: '#CBEFDB',
        UnderLine: 'DottedLine',
        context: {
          length: 2,
          offset: 35,
          text: 'Ayer fue al ercado y compr\u00f3 fruta. la manzana estaba muy dulce, pero no se la...',
        },
        contextForSureMatch: -1,
        errorHeading: 'Typographical Mistake',
        errorType: 'style',
        ignoreForIncompleteSentence: true,
        length: 2,
        location: 7,
        message: 'Esta frase no empieza con may\u00fascula.',
        offset: 35,
        replacements: [{ value: 'La' }],
        rule: {
          category: { id: 'CASING', name: 'May\u00fasculas y min\u00fasculas' },
          description:
            'Comprobar si la frase empieza con una letra may\u00fascula',
          id: 'UPPERCASE_SENTENCE_START',
          issueType: 'typographical',
        },
        sentence: 'la manzana estaba muy dulce, pero no se lacomi\u00f3.',
        shortMessage: 'May\u00fasculas y min\u00fasculas',
        type: { typeName: 'Other' },
        wrong: 'la',
        ChkiD: '2-A-0',
        text: 'Ayer fue al ercado y compro\u0301 fruta. la manzana estaba muy dulce, pero no se lacomio\u0301.',
      },
      {
        Color: '#33B66C',
        ColorLight: '#CBEFDB',
        UnderLine: 'DottedLine',
        context: {
          length: 7,
          offset: 43,
          text: '...la manzana estaba muy dulce, pero no se lacomi\u00f3.',
        },
        contextForSureMatch: 0,
        errorHeading: 'Misspelled Word',
        errorType: 'style',
        ignoreForIncompleteSentence: false,
        length: 7,
        location: -1,
        message: 'Se ha encontrado un posible error ortogr\u00e1fico.',
        offset: 75,
        replacements: [
          { value: 'la comi\u00f3' },
          { value: 'laconio' },
          { value: 'Pacomio' },
        ],
        rule: {
          category: { id: 'TYPOS', name: 'Posible error ortogr\u00e1fico' },
          description: 'Posible error de ortograf\u00eda',
          id: 'MORFOLOGIK_RULE_ES',
          issueType: 'misspelling',
        },
        sentence: 'la manzana estaba muy dulce, pero no se lacomi\u00f3.',
        shortMessage: 'Error de ortograf\u00eda',
        type: { typeName: 'UnknownWord' },
        wrong: 'lacomi\u00f3',
        ChkiD: '2-A-0',
        text: 'Ayer fue al ercado y compro\u0301 fruta. la manzana estaba muy dulce, pero no se lacomio\u0301.',
      },
    ],
    readability: 0,
    errors: {
      GrammarError: 0,
      SpellError: 0,
      Suggestion: 0,
      accuracy: 0,
      accuracy_suggestions: 0,
      clarity: 0,
      clarity_suggestions: 0,
      modelsuggestions: 0,
      redundency: 0,
      style: 0,
      style_suggestions: 0,
      syntax: 0,
      vocabulary: 0,
    },
    ChkiD: '2-A',
    text_details: {
      characters: 85,
      words: 16,
      speaking_time: 7,
      reading_time: 4,
      readability: 0,
    },
  },
  '4-A': {
    modMtch: [],
    accMode: [
      {
        errorHeading: 'Accuracy - Change the Wrong for more than three',
        correct:
          'Vamos al parque todos los domingos. Ahora est\u00e1njugando con la pelota',
        errorType: 'modAcc',
        context: { length: 67, offset: 0 },
        message: 'Try Rewriting for Clarity',
        replacements: [
          [
            '#@-@# vamos',
            '#@+@# Vamos',
            'al  parque  todos  los  domingos.  Ahora  est\u00e1njugando  con  la',
            '#@-@# pelot',
            '#@+@# pelota',
          ],
        ],
        highlights: [
          {
            wrong: 'vamos',
            offset: 0,
            replace: 'Vamos',
            length: 5,
            model: 'accuracy',
            tread_id: '4-A-0',
          },
          {
            wrong: 'pelot',
            offset: 62,
            replace: 'pelota',
            length: 5,
            model: 'accuracy',
            tread_id: '4-A-0',
          },
        ],
        length: 67,
        offset: 0,
        wrong:
          'vamos al parque todos los domingos. Ahora est\u00e1njugando con la pelot',
        Color: '#E82D53',
        ColorLight: '#FFDDDD',
        UnderLine: 'SolidLine',
        rule: {
          category: { id: 'GINMods', name: 'GINMods' },
          description: 'GINMods',
          id: 'GINMods',
          issueType: 'modAcc',
        },
        model: 'accuracy',
        ChkiD: '4-A-0',
      },
    ],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [
      {
        Color: '#33B66C',
        ColorLight: '#CBEFDB',
        UnderLine: 'DottedLine',
        context: {
          length: 12,
          offset: 43,
          text: '...mos al parque todos los domingos. Ahora est\u00e1njugando con la pelot',
        },
        contextForSureMatch: 0,
        errorHeading: 'Misspelled Word',
        errorType: 'style',
        ignoreForIncompleteSentence: false,
        length: 12,
        location: 7,
        message: 'Se ha encontrado un posible error ortogr\u00e1fico.',
        offset: 42,
        replacements: [{ value: 'est\u00e1n jugando' }],
        rule: {
          category: { id: 'TYPOS', name: 'Posible error ortogr\u00e1fico' },
          description: 'Posible error de ortograf\u00eda',
          id: 'MORFOLOGIK_RULE_ES',
          issueType: 'misspelling',
        },
        sentence: 'Ahora est\u00e1njugando con la pelot',
        shortMessage: 'Error de ortograf\u00eda',
        type: { typeName: 'UnknownWord' },
        wrong: 'est\u00e1njugando',
        ChkiD: '4-A-0',
        text: 'vamos al parque todos los domingos. Ahora esta\u0301njugando con la pelot',
      },
    ],
    readability: 0,
    errors: {
      GrammarError: 0,
      SpellError: 0,
      Suggestion: 0,
      accuracy: 0,
      accuracy_suggestions: 1,
      clarity: 0,
      clarity_suggestions: 0,
      modelsuggestions: 0,
      redundency: 0,
      style: 0,
      style_suggestions: 0,
      syntax: 0,
      vocabulary: 0,
    },
    ChkiD: '4-A',
    text_details: {
      characters: 68,
      words: 11,
      speaking_time: 5,
      reading_time: 3,
      readability: 0,
    },
  },
} as const;

const errors_pt = {
  '0-A': {
    modMtch: [],
    accMode: [],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [
      {
        Color: '#33B66C',
        ColorLight: '#CBEFDB',
        UnderLine: 'DottedLine',
        context: {
          length: 4,
          offset: 0,
          text: 'este \u00e9 um texto deexemplo.',
        },
        contextForSureMatch: -1,
        errorHeading: 'Typographical Mistake',
        errorType: 'style',
        ignoreForIncompleteSentence: true,
        length: 4,
        location: 0,
        message: 'Esta frase n\u00e3o come\u00e7a com mai\u00fascula.',
        offset: 0,
        replacements: [{ value: 'Este' }],
        rule: {
          category: {
            id: 'CASING',
            name: 'Capitaliza\u00e7\u00e3o',
            filter_list: 1,
          },
          description: 'Capitaliza\u00e7\u00e3o da frase',
          id: 'UPPERCASE_SENTENCE_START',
          issueType: 'typographical',
        },
        sentence: 'este \u00e9 um texto deexemplo.',
        shortMessage: 'Capitaliza\u00e7\u00e3o',
        type: { typeName: 'Other' },
        wrong: 'este',
        ChkiD: '0-A-0',
        text: 'este e\u0301 um texto deexemplo.',
      },
      {
        Color: '#33B66C',
        ColorLight: '#CBEFDB',
        UnderLine: 'DottedLine',
        context: {
          length: 9,
          offset: 16,
          text: 'este \u00e9 um texto deexemplo.',
        },
        contextForSureMatch: 0,
        errorHeading: 'Misspelled Word',
        errorType: 'style',
        ignoreForIncompleteSentence: false,
        length: 9,
        location: -1,
        message: 'Poss\u00edvel erro ortogr\u00e1fico',
        offset: 16,
        replacements: [{ value: 'de exemplo' }],
        rule: {
          category: {
            id: 'TYPOS',
            name: 'Erros Ortogr\u00e1ficos',
            filter_list: 1,
          },
          description: 'Poss\u00edvel erro ortogr\u00e1fico',
          id: 'MORFOLOGIK_RULE_PT',
          issueType: 'misspelling',
        },
        sentence: 'este \u00e9 um texto deexemplo.',
        shortMessage: 'Erro ortogr\u00e1fico',
        type: { typeName: 'UnknownWord' },
        wrong: 'deexemplo',
        ChkiD: '0-A-0',
        text: 'este e\u0301 um texto deexemplo.',
      },
    ],
    readability: 35,
    errors: {
      SpellError: 1,
      Suggestion: 0,
      GrammarError: 1,
      redundency: 0,
      clarity: 0,
      accuracy: 0,
      style: 2,
      syntax: 0,
      vocabulary: 0,
      modelsuggestions: 0,
      accuracy_suggestions: 0,
      clarity_suggestions: 0,
      style_suggestions: 0,
    },
    ChkiD: '0-A',
    text_details: {
      characters: 27,
      words: 5,
      speaking_time: 2,
      reading_time: 1,
      readability: 35,
    },
  },
  '1-A': {
    modMtch: [],
    accMode: [],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [
      {
        Color: '#33B66C',
        ColorLight: '#CBEFDB',
        UnderLine: 'DottedLine',
        context: {
          length: 9,
          offset: 12,
          text: 'O GrammarIn detectar\u00e1 seus erros Usando sua IA e ajudar\u00e1 voc\u00ea...',
        },
        contextForSureMatch: 0,
        errorHeading: 'Misspelled Word',
        errorType: 'style',
        ignoreForIncompleteSentence: false,
        length: 9,
        location: 2,
        message:
          'Poss\u00edvel erro de ortografia: esta \u00e9 a grafia utilizada no portugu\u00eas brasileiro.',
        offset: 12,
        replacements: [
          { shortDescription: 'Portuguese', value: 'detetar\u00e1' },
        ],
        rule: {
          category: {
            id: 'TYPOS',
            name: 'Erros Ortogr\u00e1ficos',
            filter_list: 1,
          },
          description: 'Poss\u00edvel erro ortogr\u00e1fico',
          id: 'MORFOLOGIK_RULE_PT_DIALECT',
          issueType: 'misspelling',
        },
        sentence:
          'O GrammarIn detectar\u00e1 seus erros Usando sua IA e ajudar\u00e1 voc\u00ea a escrevermelhor.',
        shortMessage: '',
        type: { typeName: 'UnknownWord' },
        wrong: 'detectar\u00e1',
        ChkiD: '1-A-0',
        text: 'O GrammarIn detectara\u0301 seus erros Usando sua IA e ajudara\u0301 voce\u0302 a escrevermelhor.',
      },
      {
        Color: '#33B66C',
        ColorLight: '#CBEFDB',
        UnderLine: 'DottedLine',
        context: {
          length: 14,
          offset: 43,
          text: '...us erros Usando sua IA e ajudar\u00e1 voc\u00ea a escrevermelhor.',
        },
        contextForSureMatch: 0,
        errorHeading: 'Misspelled Word',
        errorType: 'style',
        ignoreForIncompleteSentence: false,
        length: 14,
        location: -1,
        message: 'Poss\u00edvel erro ortogr\u00e1fico',
        offset: 64,
        replacements: [{ value: 'escrever melhor' }],
        rule: {
          category: {
            id: 'TYPOS',
            name: 'Erros Ortogr\u00e1ficos',
            filter_list: 1,
          },
          description: 'Poss\u00edvel erro ortogr\u00e1fico',
          id: 'MORFOLOGIK_RULE_PT',
          issueType: 'misspelling',
        },
        sentence:
          'O GrammarIn detectar\u00e1 seus erros Usando sua IA e ajudar\u00e1 voc\u00ea a escrevermelhor.',
        shortMessage: 'Erro ortogr\u00e1fico',
        type: { typeName: 'UnknownWord' },
        wrong: 'escrevermelhor',
        ChkiD: '1-A-0',
        text: 'O GrammarIn detectara\u0301 seus erros Usando sua IA e ajudara\u0301 voce\u0302 a escrevermelhor.',
      },
    ],
    readability: 13,
    errors: {
      SpellError: 3,
      Suggestion: 0,
      GrammarError: 0,
      redundency: 0,
      clarity: 0,
      accuracy: 0,
      style: 3,
      syntax: 0,
      vocabulary: 0,
      modelsuggestions: 0,
      accuracy_suggestions: 0,
      clarity_suggestions: 0,
      style_suggestions: 0,
    },
    ChkiD: '1-A',
    text_details: {
      characters: 82,
      words: 13,
      speaking_time: 6,
      reading_time: 3,
      readability: 13,
    },
  },
  '2-A': {
    modMtch: [],
    accMode: [],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [
      {
        Color: '#33B66C',
        ColorLight: '#CBEFDB',
        UnderLine: 'DottedLine',
        context: {
          length: 6,
          offset: 11,
          text: 'Ele foi ao mercad ontem e comprou algumas fruta.',
        },
        contextForSureMatch: -1,
        errorHeading: 'Uncategorized Mistake',
        errorType: 'style',
        ignoreForIncompleteSentence: true,
        length: 6,
        location: 3,
        message:
          'Se \u00e9 uma abreviatura, falta um ponto. Se for uma express\u00e3o, coloque entre aspas.',
        offset: 11,
        replacements: [{ value: 'mercad.' }, { value: '\u201cmercad\u201d' }],
        rule: {
          category: {
            id: 'PUNCTUATION',
            name: 'Pontua\u00e7\u00e3o',
            filter_list: 1,
          },
          description: 'Abreviaturas: Pontua\u00e7\u00e3o',
          id: 'ABREVIATIONS_PUNCTUATION',
          issueType: 'uncategorized',
          sourceFile: 'grammar.xml',
          subId: '1',
        },
        sentence: 'Ele foi ao mercad ontem e comprou algumas fruta.',
        shortMessage: 'Erro de pontua\u00e7\u00e3o',
        type: { typeName: 'Other' },
        wrong: 'mercad',
        ChkiD: '2-A-0',
        text: 'Ele foi ao mercad ontem e comprou algumas fruta.',
      },
      {
        Color: '#33B66C',
        ColorLight: '#CBEFDB',
        UnderLine: 'DottedLine',
        context: {
          length: 13,
          offset: 34,
          text: 'Ele foi ao mercad ontem e comprou algumas fruta.',
        },
        contextForSureMatch: -1,
        errorHeading: 'Grammar Mistake',
        errorType: 'style',
        ignoreForIncompleteSentence: true,
        length: 13,
        location: 7,
        message: 'Poss\u00edvel erro de concord\u00e2ncia de n\u00famero.',
        offset: 34,
        replacements: [
          { value: 'alguma fruta' },
          { value: 'algumas frutas' },
          { value: 'algumas, fruta' },
          { value: 'algumas de fruta' },
        ],
        rule: {
          category: {
            id: 'GRAMMAR',
            name: 'Gram\u00e1tica Geral',
            filter_list: 1,
          },
          description: 'Concord\u00e2ncia de N\u00famero: Geral',
          id: 'GENERAL_NUMBER_AGREEMENT_ERRORS',
          issueType: 'grammar',
          sourceFile: 'grammar.xml',
          subId: '7',
          urls: [
            {
              value:
                'https://pt.wikibooks.org/wiki/Portugu%C3%AAs/Concord%C3%A2ncia/Concord%C3%A2ncia_nominal',
            },
          ],
        },
        sentence: 'Ele foi ao mercad ontem e comprou algumas fruta.',
        shortMessage: '',
        type: { typeName: 'Other' },
        wrong: 'algumas fruta',
        ChkiD: '2-A-0',
        text: 'Ele foi ao mercad ontem e comprou algumas fruta.',
      },
      {
        Color: '#33B66C',
        ColorLight: '#CBEFDB',
        UnderLine: 'DottedLine',
        context: {
          length: 5,
          offset: 73,
          text: ' A ma\u00e7\u00e3 estava muito doce, Mas ela n\u00e3o a comeu.',
        },
        contextForSureMatch: -1,
        errorHeading: 'Grammar Mistake',
        errorType: 'style',
        ignoreForIncompleteSentence: true,
        length: 5,
        location: -1,
        message:
          ', n\u00e3o encerra frases; portanto, se n\u00e3o for um nome pr\u00f3prio, a palavra seguinte deve ser iniciada com letra min\u00fascula.',
        offset: 73,
        replacements: [{ value: ', mas' }, { value: '. Mas' }],
        rule: {
          category: {
            id: 'CASING',
            name: 'Capitaliza\u00e7\u00e3o',
            filter_list: 1,
          },
          description: 'Mai\u00fasculas depois de uma v\u00edrgula',
          id: 'UPPERCASE_AFTER_COMMA',
          issueType: 'grammar',
          sourceFile: 'grammar.xml',
          subId: '1',
        },
        sentence:
          'A ma\u00e7\u00e3 estava muito doce, Mas ela n\u00e3o a comeu.',
        shortMessage: '',
        type: { typeName: 'Other' },
        wrong: ', Mas',
        ChkiD: '2-A-1',
        text: ' A mac\u0327a\u0303 estava muito doce, Mas ela na\u0303o a comeu.',
      },
    ],
    readability: 40,
    errors: {
      SpellError: 0,
      Suggestion: 0,
      GrammarError: 3,
      redundency: 0,
      clarity: 0,
      accuracy: 0,
      style: 3,
      syntax: 0,
      vocabulary: 0,
      modelsuggestions: 0,
      accuracy_suggestions: 0,
      clarity_suggestions: 0,
      style_suggestions: 0,
    },
    ChkiD: '2-A',
    text_details: {
      characters: 98,
      words: 19,
      speaking_time: 9,
      reading_time: 5,
      readability: 40,
    },
  },
  '3-A': {
    modMtch: [],
    accMode: [],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [
      {
        Color: '#33B66C',
        ColorLight: '#CBEFDB',
        UnderLine: 'DottedLine',
        context: {
          length: 8,
          offset: 0,
          text: 'N\u00f3svamos ao parque todos os Domingos. eles est\u00e3o...',
        },
        contextForSureMatch: 0,
        errorHeading: 'Misspelled Word',
        errorType: 'style',
        ignoreForIncompleteSentence: false,
        length: 8,
        location: 0,
        message: 'Poss\u00edvel erro ortogr\u00e1fico',
        offset: 0,
        replacements: [
          { value: 'Noivamos' },
          { value: 'Noiv\u00e1mos' },
          { value: 'N\u00f3s vamos' },
        ],
        rule: {
          category: {
            id: 'TYPOS',
            name: 'Erros Ortogr\u00e1ficos',
            filter_list: 1,
          },
          description: 'Poss\u00edvel erro ortogr\u00e1fico',
          id: 'MORFOLOGIK_RULE_PT',
          issueType: 'misspelling',
        },
        sentence: 'N\u00f3svamos ao parque todos os Domingos.',
        shortMessage: 'Erro ortogr\u00e1fico',
        type: { typeName: 'UnknownWord' },
        wrong: 'N\u00f3svamos',
        ChkiD: '3-A-0',
        text: 'No\u0301svamos ao parque todos os Domingos. eles esta\u0303o brincando com a bola agora',
      },
      {
        Color: '#33B66C',
        ColorLight: '#CBEFDB',
        UnderLine: 'DottedLine',
        context: {
          length: 4,
          offset: 38,
          text: 'N\u00f3svamos ao parque todos os Domingos. eles est\u00e3o brincando com a bola agora',
        },
        contextForSureMatch: -1,
        errorHeading: 'Typographical Mistake',
        errorType: 'style',
        ignoreForIncompleteSentence: true,
        length: 4,
        location: 6,
        message: 'Esta frase n\u00e3o come\u00e7a com mai\u00fascula.',
        offset: 38,
        replacements: [{ value: 'Eles' }],
        rule: {
          category: {
            id: 'CASING',
            name: 'Capitaliza\u00e7\u00e3o',
            filter_list: 1,
          },
          description: 'Capitaliza\u00e7\u00e3o da frase',
          id: 'UPPERCASE_SENTENCE_START',
          issueType: 'typographical',
        },
        sentence: 'eles est\u00e3o brincando com a bola agora',
        shortMessage: 'Capitaliza\u00e7\u00e3o',
        type: { typeName: 'Other' },
        wrong: 'eles',
        ChkiD: '3-A-0',
        text: 'No\u0301svamos ao parque todos os Domingos. eles esta\u0303o brincando com a bola agora',
      },
    ],
    readability: 38,
    errors: {
      SpellError: 1,
      Suggestion: 0,
      GrammarError: 1,
      redundency: 0,
      clarity: 0,
      accuracy: 0,
      style: 2,
      syntax: 0,
      vocabulary: 0,
      modelsuggestions: 0,
      accuracy_suggestions: 0,
      clarity_suggestions: 0,
      style_suggestions: 0,
    },
    ChkiD: '3-A',
    text_details: {
      characters: 77,
      words: 13,
      speaking_time: 6,
      reading_time: 3,
      readability: 38,
    },
  },
} as const;

const errors_de = {
  '0-A': {
    modMtch: [],
    accMode: [],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [
      {
        ChkiD: '0-A-0',
        ColorLight: '#FFDDDD',
        Color: '#E82D53',
        UnderLine: 'SolidLine',
        context: { length: 4, offset: 0 },
        errorHeading: '',
        errorType: 'accuracy',
        contextForSureMatch: -1,
        ignoreForIncompleteSentence: true,
        length: 4,
        location: -1,
        message: 'Seems inaccurate, consider correcting it.',
        offset: 0,
        replacements: [{ value: 'Dies' }],
        rule: {
          category: { filter_list: 1, id: 'gin_grammar', name: 'GINMods' },
          description: 'GINMods',
          id: 'gin_grammar',
          issueType: 'accuracy',
        },
        sentence: 'DIes ist ein Beispieltext.',
        shortMessage: 'Seems inaccurate, consider correcting it.',
        text: 'DIes ist ein Beispieltext.',
        type: { typeName: 'Other' },
        wrong: 'DIes',
      },
    ],
    readability: 0,
    errors: {
      GrammarError: 0,
      SpellError: 0,
      Suggestion: 0,
      accuracy: 0,
      accuracy_suggestions: 0,
      clarity: 0,
      clarity_suggestions: 0,
      modelsuggestions: 0,
      redundency: 0,
      style: 0,
      style_suggestions: 0,
      syntax: 0,
      vocabulary: 0,
    },
    ChkiD: '0-A',
    text_details: {
      characters: 26,
      words: 4,
      speaking_time: 2,
      reading_time: 1,
      readability: 0,
    },
  },
  '7-A': {
    modMtch: [],
    accMode: [
      {
        errorHeading: 'Accuracy - Change the Wrong for more than three',
        correct:
          'Wir gehen jeden Sonntag in den Park, sie spielen jetzt mit ihrem Ball.',
        errorType: 'modAcc',
        context: { length: 65, offset: 0 },
        message: 'Try Rewriting for Clarity',
        replacements: [
          [
            '#@-@# wir',
            '#@+@# Wir',
            'gehen',
            '#@-@# jedenonntag',
            '#@+@# jeden  Sonntag',
            'in  den',
            '#@-@# Park.',
            '#@+@# Park,',
            '#@-@# ie',
            '#@+@# sie',
            'spielen  jetzt  mit',
            '#@-@# ihremBall',
            '#@+@# ihrem  Ball.',
          ],
        ],
        highlights: [
          {
            wrong: 'wir',
            offset: 0,
            replace: 'Wir',
            length: 3,
            model: 'accuracy',
            tread_id: '7-A-0',
          },
          {
            wrong: 'jedenonntag',
            offset: 10,
            replace: 'jeden Sonntag',
            length: 11,
            model: 'accuracy',
            tread_id: '7-A-0',
          },
          {
            wrong: 'Park. ie',
            offset: 29,
            replace: 'Park, sie',
            length: 8,
            model: 'accuracy',
            tread_id: '7-A-0',
          },
          {
            wrong: 'ihremBall',
            offset: 56,
            replace: 'ihrem Ball.',
            length: 9,
            model: 'accuracy',
            tread_id: '7-A-0',
          },
        ],
        length: 65,
        offset: 0,
        wrong:
          'wir gehen jedenonntag in den Park. ie spielen jetzt mit ihremBall',
        Color: '#E82D53',
        ColorLight: '#FFDDDD',
        UnderLine: 'SolidLine',
        rule: {
          category: { id: 'GINMods', name: 'GINMods' },
          description: 'GINMods',
          id: 'GINMods',
          issueType: 'modAcc',
        },
        model: 'accuracy',
        ChkiD: '7-A-0',
      },
    ],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [],
    readability: 0,
    errors: {
      GrammarError: 0,
      SpellError: 0,
      Suggestion: 0,
      accuracy: 0,
      accuracy_suggestions: 1,
      clarity: 0,
      clarity_suggestions: 0,
      modelsuggestions: 0,
      redundency: 0,
      style: 0,
      style_suggestions: 0,
      syntax: 0,
      vocabulary: 0,
    },
    ChkiD: '7-A',
    text_details: {
      characters: 65,
      words: 11,
      speaking_time: 5,
      reading_time: 3,
      readability: 0,
    },
  },
  '5-A': {
    modMtch: [],
    accMode: [],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [
      {
        ChkiD: '5-A-0',
        ColorLight: '#FFDDDD',
        Color: '#E82D53',
        UnderLine: 'SolidLine',
        context: { length: 8, offset: 66 },
        errorHeading: '',
        errorType: 'accuracy',
        contextForSureMatch: -1,
        ignoreForIncompleteSentence: true,
        length: 8,
        location: -1,
        message: 'Seems inaccurate, consider correcting it.',
        offset: 66,
        replacements: [{ value: 'besser zu' }],
        rule: {
          category: { filter_list: 1, id: 'gin_grammar', name: 'GINMods' },
          description: 'GINMods',
          id: 'gin_grammar',
          issueType: 'accuracy',
        },
        sentence:
          'GrammarIn erkennt Ihre Fehler Mithilfe seiner KI und hilft Ihnen, besserzu schreiben.',
        shortMessage: 'Seems inaccurate, consider correcting it.',
        text: 'GrammarIn erkennt Ihre Fehler Mithilfe seiner KI und hilft Ihnen, besserzu schreiben.',
        type: { typeName: 'Other' },
        wrong: 'besserzu',
      },
    ],
    readability: 0,
    errors: {
      GrammarError: 0,
      SpellError: 0,
      Suggestion: 0,
      accuracy: 0,
      accuracy_suggestions: 0,
      clarity: 0,
      clarity_suggestions: 0,
      modelsuggestions: 0,
      redundency: 0,
      style: 0,
      style_suggestions: 0,
      syntax: 0,
      vocabulary: 0,
    },
    ChkiD: '5-A',
    text_details: {
      characters: 85,
      words: 12,
      speaking_time: 6,
      reading_time: 3,
      readability: 0,
    },
  },
  '6-A': {
    modMtch: [],
    accMode: [
      {
        errorHeading: 'Accuracy - Change the Wrong for more than three',
        correct:
          'Gestern ging er zum Markt und kaufte Obst Der Apfel war sehr s\u00fc\u00df, aber sie a\u00df ihn nicht.',
        errorType: 'modAcc',
        context: { length: 86, offset: 0 },
        message: 'Try Rewriting for Clarity',
        replacements: [
          [
            'Gestern',
            '#@-@# gin',
            '#@+@# ging',
            'er  zum  Markt  und  kaufte  Obst  Der  Apfel  war  sehr  s\u00fc\u00df,  aber  sie  a\u00df',
            '#@+@# ihn',
            '#@-@# ihnnicht.',
            '#@+@# nicht.',
          ],
        ],
        highlights: [
          {
            wrong: 'gin',
            offset: 8,
            replace: 'ging',
            length: 3,
            model: 'accuracy',
            tread_id: '6-A-0',
          },
          {
            wrong: 'ihnnicht.',
            offset: 77,
            replace: 'ihn nicht.',
            length: 9,
            model: 'accuracy',
            tread_id: '6-A-0',
          },
        ],
        length: 86,
        offset: 0,
        wrong:
          'Gestern gin er zum Markt und kaufte Obst Der Apfel war sehr s\u00fc\u00df, aber sie a\u00df ihnnicht.',
        Color: '#E82D53',
        ColorLight: '#FFDDDD',
        UnderLine: 'SolidLine',
        rule: {
          category: { id: 'GINMods', name: 'GINMods' },
          description: 'GINMods',
          id: 'GINMods',
          issueType: 'modAcc',
        },
        model: 'accuracy',
        ChkiD: '6-A-0',
      },
    ],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [
      {
        Color: '#33B66C',
        ColorLight: '#CBEFDB',
        UnderLine: 'DottedLine',
        context: {
          length: 3,
          offset: 43,
          text: '...estern gin er zum Markt und kaufte Obst Der Apfel war sehr s\u00fc\u00df, aber sie a\u00df ihnnich...',
        },
        contextForSureMatch: 9,
        errorHeading: 'Uncategorized Mistake',
        errorType: 'style',
        ignoreForIncompleteSentence: true,
        length: 3,
        location: 8,
        message:
          'Au\u00dfer am Satzanfang werden nur Nomen und Eigennamen gro\u00dfgeschrieben.',
        offset: 41,
        replacements: [{ value: 'der' }],
        rule: {
          category: { id: 'CASING', name: 'Gro\u00df-/Kleinschreibung' },
          description:
            'Gro\u00dfschreibung von Nomen und substantivierten Verben',
          id: 'DE_CASE',
          issueType: 'uncategorized',
          urls: [
            {
              value:
                'https://dict.leo.org/grammatik/deutsch/Rechtschreibung/Regeln/Gross-klein/index.html',
            },
          ],
        },
        sentence:
          'Gestern gin er zum Markt und kaufte Obst Der Apfel war sehr s\u00fc\u00df, aber sie a\u00df ihnnicht.',
        shortMessage: '',
        type: { typeName: 'Other' },
        wrong: 'Der',
        ChkiD: '6-A-0',
        text: 'Gestern gin er zum Markt und kaufte Obst Der Apfel war sehr su\u0308\u00df, aber sie a\u00df ihnnicht.',
      },
    ],
    readability: 0,
    errors: {
      GrammarError: 0,
      SpellError: 0,
      Suggestion: 0,
      accuracy: 0,
      accuracy_suggestions: 1,
      clarity: 0,
      clarity_suggestions: 0,
      modelsuggestions: 0,
      redundency: 0,
      style: 0,
      style_suggestions: 0,
      syntax: 0,
      vocabulary: 0,
    },
    ChkiD: '6-A',
    text_details: {
      characters: 87,
      words: 17,
      speaking_time: 8,
      reading_time: 4,
      readability: 0,
    },
  },
};

const text_en = `<p><strong id="0-A">THis is a samplee text.</strong></p><p><br></p><p id=\"1-A\" class=\"\">GrammarIn wills detected you mistakes usng its AI and helps your write better.</p><p id=\"2-A\" class=\"\">he walk to market yesterday and buyed some fruits. the apple was very sweet but she not eat it.</p><p id=\"3-A\" class=\"\">we goes to park every sundays. they is playing with there ball now.</p>`;

const text_es = `<p id=\"0-A\" class=\"\"><u>este</u> es un texto <u>deejemplo</u>.</p><p id=\"1-A\" class=\"\">GrammarIn detectar\u00e1 tus errores <u>Con</u> su <u>inteligenciaartificia</u>l y te ayudar\u00e1 a escribir mejor.</p><p id=\"2-A\" class=\"\">Ayer fue al <u>ercado</u> y compr\u00f3 fruta. <u>la</u> manzana estaba muy dulce, pero no se <u>lacomi\u00f3</u>.</p><p id=\"3-A\" class=\"\"><br/></p><p id=\"4-A\" class=\"\"><u>vamos</u> al parque todos los domingos. Ahora <u>est\u00e1njugando</u> con la <u>pelot</u></p>`;

const text_pt = `<p id=\"0-A\" class=\"\">este \u00e9 um texto deexemplo.</p><p id=\"1-A\" class=\"\">O GrammarIn detectar\u00e1 seus erros Usando sua IA e ajudar\u00e1 voc\u00ea a escrevermelhor.</p><p id=\"2-A\" class=\"\">Ele foi ao mercad ontem e comprou algumas fruta. A ma\u00e7\u00e3 estava muito doce, Mas ela n\u00e3o a comeu.</p><p id=\"3-A\" class=\"\">N\u00f3svamos ao parque todos os Domingos. eles est\u00e3o brincando com a bola agora</p>`;

const text_de = `<p id=\"0-A\" class=\"\">DIes ist ein Beispieltext.</p><p id=\"1-A\" class=\"\"><br/></p><p id=\"2-A\" class=\"\"><br/></p><p id=\"3-A\" class=\"\"><br/></p><p id=\"4-A\" class=\"\"><br/></p><p id=\"5-A\" class=\"\">GrammarIn erkennt Ihre Fehler Mithilfe seiner KI und hilft Ihnen, besserzu schreiben.</p><p id=\"6-A\" class=\"\">Gestern gin er zum Markt und kaufte Obst Der Apfel war sehr s\u00fc\u00df, aber sie a\u00df ihnnicht.</p><p id=\"7-A\" class=\"\">wir gehen jedenonntag in den Park. ie spielen jetzt mit ihremBall</p><p id=\"8-A\" class=\"\"><br/></p>`;

const sampleText = {
  en: {
    text: text_en,
    errors: errors_en,
  },
  es: {
    text: text_es,
    errors: errors_es,
  },
  pt: {
    text: text_pt,
    errors: errors_pt,
  },
  de: {
    text: text_de,
    errors: errors_de,
  },
} as const;

export {
  errors_en,
  errors_es,
  errors_pt,
  errors_de,
  text_en,
  text_es,
  text_pt,
  text_de,
  sampleText as default,
};
